import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FiX } from "react-icons/fi";
import { theme } from "../../styles/theme";
import { Modal } from "../ui/Modal";
import { Button } from "../ui/Button";
import { Label } from "../ui/Input";

const Layout = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md};
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Actions = styled.div`
  display: flex;
  gap: ${theme.spacing.sm};
  justify-content: flex-end;
  flex-wrap: wrap;
`;

const InfoText = styled.p`
  color: ${theme.colors.text.secondary};
  font-size: ${theme.typography.fontSize.sm};
  white-space: pre-wrap;
  background: ${theme.colors.background.tertiary};
  padding: ${theme.spacing.sm};
  border-radius: ${theme.borderRadius.md};
  margin: 0;
  max-height: 100px;
  overflow-y: auto;
`;

function RetryDialog({ isOpen, version, onClose, onSubmit }) {
  const [quality, setQuality] = useState("pro");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setQuality("pro");
      setLoading(false);
    }
  }, [isOpen]);

  if (!version) return null;

  const handleSubmit = async (event) => {
    event.preventDefault();
    onSubmit?.(version, quality);
    onClose?.();
  };

  return (
    <Modal isOpen={isOpen} onClose={loading ? undefined : onClose}>
      <Layout onSubmit={handleSubmit}>
        <Header>
          <h3 style={{ margin: 0 }}>Retry Remix</h3>
          <Button variant="ghost" type="button" onClick={onClose} disabled={loading}>
            <FiX />
          </Button>
        </Header>

        {version.pending_remix_prompt && (
            <div style={{ display: "flex", flexDirection: "column", gap: theme.spacing["2xs"] }}>
                <Label>Original Prompt</Label>
                <InfoText>{version.pending_remix_prompt}</InfoText>
            </div>
        )}

        <div style={{ display: "flex", flexDirection: "column", gap: theme.spacing["2xs"] }}>
          <Label htmlFor="retry-quality">Quality</Label>
          <select
            id="retry-quality"
            value={quality}
            onChange={(e) => setQuality(e.target.value)}
            disabled={loading}
            style={{
              padding: theme.spacing.sm,
              borderRadius: theme.borderRadius.md,
              border: theme.borders.base,
              width: "100%",
            }}
          >
            <option value="pro">PRO (default)</option>
            <option value="fast">FAST (seedream 4.5)</option>
          </select>
        </div>

        <Actions>
          <Button type="button" variant="secondary" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button type="submit" disabled={loading}>
            {loading ? "Retrying..." : "Retry"}
          </Button>
        </Actions>
      </Layout>
    </Modal>
  );
}

export default RetryDialog;

